/**
 * Created by mykurisu on 2017/9/25.
 */
import React from 'react'
import axios from 'axios'
import {Dialog, Toast} from 'react-weui'


class PushComponent extends React.Component {
    static defaultProps = {
        type: 'lecture',
        dialogShow: false,
        target_id: null
    };

    constructor() {
        super();
        this.state = {
            initialized: false,
            pushShow: true,
            complete: false,
            toastShow: false,
            dialogButton: {
                finishButton: [
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.handleDialogShow.bind(this)
                    }
                ],
                pushButton: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.handleDialogShow.bind(this)
                    },
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.handleComplete.bind(this)
                    }
                ],
                completeButton: [
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.handleDialogCompleteShow.bind(this)
                    }
                ],
            }
        }
    }

    componentDidMount() {
        let target_id = this.props.target_id;
        let target_url = '';
        if (this.props.type === 'lecture'){
            target_url = `/api/lecture/${target_id}/check_push`
        }else if (this.props.type === 'liveroom'){
            target_url = `/api/liveroom/${target_id}/vip/check_push`
        }else {
            target_url = `/api/channel/${target_id}/check_push`
        }
        axios.post(target_url).then(res => {
            if (res.data.code === 0) {
                this.setState(Object.assign(res.data.data, {initialized: true}));
            }
        });
    }

    handleDialogShow() {
        this.props.handleHidePush();
    }

    handleComplete() {
        let target_id = this.props.target_id;
        let target_url = '';
        if (this.props.type === 'lecture'){
            target_url = `/api/lecture/${target_id}/push`
        }else if (this.props.type === 'liveroom'){
            target_url = `/api/liveroom/${target_id}/vip/push`
        }else {
            target_url = `/api/channel/${target_id}/push`
        }
        this.setState({
            pushShow: false,
            toastShow: true
        });
        axios.post(target_url).then(res => {
            this.setState({toastShow: false});
            if (res.data.code === 0) {
                this.setState({
                    code: res.data.code,
                    complete: true,
                    msg: res.data.msg
                });
            } else {
                this.context.page.showAlert(res.data.msg)
            }
        })
    }

    handleDialogCompleteShow() {
        this.props.handleHidePush();
    }

    render() {
        let {initialized, msg, can_push, dialogButton, push_time, pushShow} = this.state;

        if (!initialized) {
            return null;
        }
        return (
            <div>
                <Toast icon="loading" show={this.state.toastShow}>

                </Toast>
                <Dialog title={this.props.type === 'liveroom' ? `本月有${push_time}次推送机会` : `还剩${push_time}次推送机会`} 
                        buttons={can_push ? dialogButton.pushButton : dialogButton.finishButton}
                        show={!this.state.code && pushShow}>
                    <p>{msg}</p>
                </Dialog>
                {this.state.code === 0 &&
                <Dialog buttons={this.state.dialogButton.completeButton} show={this.state.complete}>
                    <p>推送成功，{this.props.type === 'liveroom' ? '24' : '8'}小时后可再次推送</p>
                </Dialog>
                }
            </div>
        )
    }
}

PushComponent.contextTypes = {
    page: React.PropTypes.object
};

export default PushComponent



// WEBPACK FOOTER //
// ./src/components/details/PushComponent.js